import React, {useState} from 'react'
import { TextInput, PasswordInput, Button } from '@mantine/core';
import { useForm } from '@mantine/form';
import { ResetPasswordRequestFormValidations } from './validations/FormValidations';
import { AppDataService } from '../../services/AppDataService';
import useInfoModal from '../../hooks/useInfoModal';
import { MODAL_TYPE_ENUM } from '../../enums/CommonEnums';

const ResetPasswordRequestForm = () => {
  const form = useForm({
    initialValues: {
      email: "",
    },

    // functions will be used to validate values at corresponding key
    validate: ResetPasswordRequestFormValidations
  });
  const openModal = useInfoModal();
  const [loading, setLoading] = useState(false);

  const handleSendResetRequest = async () => {
    try {
      setLoading(true);
  
      const webResp = await AppDataService.SendResetPasswordRequest({
        emailAddress: form.values.email,
      });
      const responseData = webResp.getResponse();
  
      setLoading(false);
  
      openModal(MODAL_TYPE_ENUM.RESET_PASSWORD_SUCCESS);
    }
    catch(err) {
      setLoading(false);
      openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, err.message);
    }
  }

  return (
    <form onSubmit={form.onSubmit(handleSendResetRequest)}>
      <TextInput label="Email address" placeholder="hello@gmail.com" size="md" {...form.getInputProps('email')} />
      <Button fullWidth mt="xl" size="md" type="submit" loading={loading}>Send Request</Button>
    </form>
  )
}

export default ResetPasswordRequestForm;